package fr.manyverse.app.infrastructure.cache

import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.repository.GameEventCacheRepository

/**
 * In-memory cache of the most recent unfiltered events per table.
 * Survives ViewModel recompositions/recreations within the same process lifetime.
 */
class GameEventCache : GameEventCacheRepository {
    private val perTable = mutableMapOf<String, List<GameEvent>>()

    override fun getEvents(tableId: String): List<GameEvent>? = perTable[tableId]

    override fun setEvents(tableId: String, events: List<GameEvent>) {
        perTable[tableId] = events
    }

    override fun upsertEvent(tableId: String, event: GameEvent) {
        val current = perTable[tableId] ?: return
        val withoutDup = current.filterNot { it.id == event.id }
        perTable[tableId] = (listOf(event) + withoutDup).sortedByDescending { it.createdAt }
    }

    override fun clear() {
        perTable.clear()
    }
}
